export default {"src":"/_next/static/media/stripe.d5f07830.svg","height":50,"width":50};